"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stickerSchema = exports.botStickerSchema = exports.userStickerSchema = exports.stickerBaseSchema = void 0;
const zod_1 = require("zod");
const base_1 = require("../base");
exports.stickerBaseSchema = zod_1.z.object({
    kind: zod_1.z.literal("sticker"),
    stickerURL: zod_1.z.string(),
});
exports.userStickerSchema = exports.stickerBaseSchema.merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("user") }));
exports.botStickerSchema = exports.stickerBaseSchema.merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.enum(["bot", "system"]) }));
exports.stickerSchema = zod_1.z.discriminatedUnion("from", [
    exports.userStickerSchema,
    exports.botStickerSchema,
]);
//# sourceMappingURL=sticker.js.map